const SITE = "https://anouappran.com";
const BANK = "MCB 000456560130 (KMP Lagoon Rentals Ltd)";

const refs = (parent, children) =>
  children.length ? children.map((c) => `${(parent || "").trim()}_${(c.name || "").trim()}_Grade ${c.grade}`).join(" / ") : "Parent name_Child name_Grade";

export function trialInvite(parent, children = []) {
  const name = (parent || "").trim();
  const kids = children.map((c) => c.name).filter(Boolean).join(", ");
  return [
    `Hello ${name} 😊🎁 Good news: ${kids || "your child"} can now enjoy 10 minutes of FULL access to Anou Appran for free!`,
    "Every subject of their Grade, every chapter, the rewards and the Reading kit with Kiko (English & French).",
    `👉 Log in, open your parent space and tap "Start the 10-min free trial": ${SITE}`,
    "💡 Choose a plan within 5 days after the trial and your child keeps all their progress.",
    "",
    "———",
    "",
    `Bonjour ${name} 😊🎁 Bonne nouvelle : ${kids || "votre enfant"} peut profiter de 10 minutes d'accès COMPLET à Anou Appran, gratuitement !`,
    "Toutes les matières de son Grade, tous les chapitres, les récompenses et le kit Lecture avec Kiko (anglais & français).",
    `👉 Connectez-vous, ouvrez votre espace parent et appuyez sur « Start the 10-min free trial » : ${SITE}`,
    "💡 Choisissez une formule dans les 5 jours après l'essai et votre enfant garde toute sa progression.",
  ].join("\n");
}


export function paymentReminder(parent, children = []) {
  const name = (parent || "").trim();
  const ref = refs(parent, children);
  return [
    `Hello ${name} 😊 Thank you for trying Anou Appran! 📚`,
    "Ready to help your child revise in a fun new way? 🎮",
    "",
    "💰 1 subject: Rs 200/month",
    "📚 3 subjects: Rs 500/month",
    "🎓 5 subjects: Rs 800/month",
    "",
    `🚀 To unlock full access: log in at ${SITE}, choose your plan and follow the payment instructions.`,
    `🏦 Bank transfer: ${BANK}`,
    `🧾 Payment reference: ${ref}`,
    "Need help? Just reply here! ❤️",
    "",
    "———",
    "",
    `Bonjour ${name} 😊 Merci d'avoir testé Anou Appran ! 📚`,
    "Prêt(e) à aider votre enfant à réviser autrement ? 🎮",
    "",
    "💰 1 matière : Rs 200/mois",
    "📚 3 matières : Rs 500/mois",
    "🎓 5 matières : Rs 800/mois",
    "",
    "🚀 Pour activer l'accès complet :",
    `👉 Connectez-vous : ${SITE}`,
    "Choisissez votre formule et suivez les instructions de paiement.",
    `🏦 Virement : ${BANK}`,
    `🧾 Référence de paiement : ${ref}`,
    "",
    "Besoin d'aide ? Répondez ici, je vous accompagne ! ❤️",
  ].join("\n");
}

export function renewalReminder(parent, child) {
  const name = (parent || "").trim();
  const ref = child ? refs(parent, [child]) : refs(parent, []);
  return [
    `Hello ${name} 😊📚 Your Anou Appran subscription${child ? ` for ${child.name}` : ""} is ending soon for this month!`,
    "So that your child can keep revising and progressing without a break, remember to renew for next month. ❤️",
    `👉 Renew here: ${SITE}`,
    `🧾 Payment reference: ${ref}`,
    "Thank you for your trust and support! 🌟",
    "",
    "———",
    "",
    `Bonjour ${name} 😊📚 Votre abonnement Anou Appran arrive bientôt à sa fin pour ce mois-ci !`,
    "",
    "Pour que votre enfant continue à réviser et à progresser sans interruption, pensez à renouveler votre abonnement pour le mois prochain. ❤️",
    "",
    `👉 Renouvelez ici : ${SITE}`,
    `🧾 Référence de paiement : ${ref}`,
    "",
    "Merci pour votre confiance et votre soutien à Anou Appran ! 🌟",
  ].join("\n");
}


export function readingReminder(parent, child, langs = []) {
  const name = (parent || "").trim();
  const ref = refs(parent, child ? [child] : []);
  const en = langs.map((l) => (l === "fr" ? "French" : "English")).join(" & ");
  const fr = langs.map((l) => (l === "fr" ? "français" : "anglais")).join(" & ");
  return [
    `Hello ${name} 😊📖 The Reading kit with Kiko${child ? ` for ${child.name}` : ""} (${en}) is ending soon!`,
    "Renew it so your child keeps reading every day: Rs 200 per language per month.",
    "💡 Tip: with 3 subjects (Rs 500/month) the Reading kit in English & French is included for free.",
    `👉 Renew here: ${SITE}`,
    `🧾 Payment reference: ${ref}`,
    "",
    "———",
    "",
    `Bonjour ${name} 😊📖 Le kit Lecture avec Kiko${child ? ` de ${child.name}` : ""} (${fr}) arrive bientôt à sa fin !`,
    "Renouvelez-le pour que votre enfant continue à lire chaque jour : Rs 200 par langue et par mois.",
    "💡 Astuce : avec 3 matières (Rs 500/mois), le kit Lecture anglais & français est inclus gratuitement.",
    `👉 Renouvelez ici : ${SITE}`,
    `🧾 Référence de paiement : ${ref}`,
  ].join("\n");
}
